




















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

interface TabInterface {
  to: string;
  name: string;
}

@Component
export default class MenuTabs extends Vue {
  @Prop({
    default: [],
    type: Array,
    required: true
  })
  private readonly items!: TabInterface[];
}
